import { Viewport } from "../../constants"
import useWindowSize from "../use-window-size"

function useBreakpoint() {
  const { width } = useWindowSize()

  return {
    /** @deprecated */
    isXSmallBreakpoint: width <= Viewport.xsmall,
    isSmallBreakpoint: width <= Viewport.small,
    isMediumBreakpoint: width <= Viewport.medium,
    isLargeBreakpoint: width > Viewport.medium,
  }
}

export default useBreakpoint
